"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferingNames = exports.SupportedLanguages = exports.ProxyModeType = exports.OpeningMethod = exports.IntegrationMethod = exports.ApplicationMode = exports.AppStateEnum = exports.SDKStateEnum = exports.ClientPageType = exports.ActionID = exports.DeviceType = exports.PaymentAppType = exports.AppType = exports.SDKIdentifiers = exports.PageType = exports.LevelApp = exports.ProductPackageToID = exports.OpeningMode = exports.SupportedApplicationModes = exports.AppIdentifiers = exports.AreaType = exports.TriggerType = void 0;
var TriggerType;
(function (TriggerType) {
    TriggerType["automaticFlow"] = "automaticFlow";
    TriggerType["userSelection"] = "userSelection";
})(TriggerType = exports.TriggerType || (exports.TriggerType = {}));
var AreaType;
(function (AreaType) {
    AreaType["email"] = "email";
    AreaType["button"] = "button";
    AreaType["banner"] = "banner";
    AreaType["externalClick"] = "externalClick";
    AreaType["tesetchannel"] = "tesetchannel";
    AreaType["UD"] = "UD";
    AreaType["Banner"] = "Banner";
    AreaType["ConfirmationScrean"] = "ConfirmationScreen";
    AreaType["Email"] = "Email";
    AreaType["HamburgerMenu"] = "Hamburger menu";
    AreaType["Header"] = "Header";
    AreaType["Message"] = "Message";
    AreaType["OMG"] = "OMG";
    AreaType["Overlay"] = "Overlay";
    AreaType["PCHeader"] = "PC Header";
    AreaType["PCLeftNavigationMenu"] = "PC Left navigation menu";
    AreaType["PendingAction"] = "Pending action";
    AreaType["Promotions"] = "Promotions";
    AreaType["SportBetslip"] = "Sport Betslip";
    AreaType["StaightToCashier"] = "Straight to Cashier";
    AreaType["UserArea"] = "User area";
    AreaType["NavigationMenu"] = "Navigation menu";
    AreaType["StraightToCashier"] = "Straight to cashier";
    AreaType["InGame"] = "In game";
})(AreaType = exports.AreaType || (exports.AreaType = {}));
var AppIdentifiers;
(function (AppIdentifiers) {
    AppIdentifiers["FullCashier"] = "PAYMENTS_FULLCASHIER";
    AppIdentifiers["PokerBlast"] = "POKER_BLAST";
    AppIdentifiers["PokerGamesWidget"] = "POKER_GAMES_WIDGET";
    AppIdentifiers["PokerMockIframeWidget"] = "POKER_MOCK_IFRAME_WIDGET";
    AppIdentifiers["PokerMockWidget"] = "POKER_MOCK_WIDGET";
    AppIdentifiers["Redirect"] = "PAYMENTS_PSPREDIRECT";
    AppIdentifiers["SportKambi"] = "SPORT_KAMBICLIENT";
    AppIdentifiers["SportOffering"] = "SPORT_OFFERING";
    AppIdentifiers["SportSpectate"] = "SPORT_CLIENT";
    AppIdentifiers["TransactionHistory"] = "PAYMENTS_PLAYER_TRANSACTIONS_HISTORY";
    AppIdentifiers["UnifiedCashier"] = "PAYMENTS_DEPOSIT";
    AppIdentifiers["UnifiedClient"] = "UO_UNIFIEDCLIENT";
    AppIdentifiers["Unknown"] = "UNKNOWN";
    AppIdentifiers["Withdrawal"] = "PAYMENTS_WITHDRAWAL";
    AppIdentifiers["CrChat"] = "CR_CHAT";
    AppIdentifiers["OpenBanking"] = "OPEN_BANKING";
    AppIdentifiers["CasinoClient"] = "CASINO_CLIENT";
    AppIdentifiers["UploadDocuments"] = "UPLOAD_DOCUMENTS";
    AppIdentifiers["UnifiedCashout"] = "PAYMENTS_CASHOUT";
    AppIdentifiers["OldChat"] = "CUSTOMERRELATIONS_CONTACT";
    AppIdentifiers["CustomerRelations"] = "CUSTOMERRELATIONS_CONTACT";
    AppIdentifiers["CRChat"] = "CR_CHAT";
    AppIdentifiers["CRChatBubble"] = "CR_CHAT_BUBBLE";
    AppIdentifiers["PokerHistory"] = "POKER_HISTORY";
    AppIdentifiers["UnifiedClientNative"] = "UO_UNIFIEDCLIENTNATIVE";
    AppIdentifiers["CRHelpCenter"] = "CR_HELP_CENTER";
    AppIdentifiers["CasinoBonusGameWidget"] = "CASINO_BONUS_GAME_WIDGET";
    AppIdentifiers["OpenEmail"] = "OPEN_EMAIL";
    AppIdentifiers["OpenOnlineHelp"] = "OPEN_ONLINE_HELP";
})(AppIdentifiers = exports.AppIdentifiers || (exports.AppIdentifiers = {}));
var SupportedApplicationModes;
(function (SupportedApplicationModes) {
    SupportedApplicationModes["Proxy"] = "Proxy";
    SupportedApplicationModes["Full"] = "Full";
})(SupportedApplicationModes = exports.SupportedApplicationModes || (exports.SupportedApplicationModes = {}));
var OpeningMode;
(function (OpeningMode) {
    OpeningMode["rightSideDrawer"] = "rightSideDrawer";
    OpeningMode["popup"] = "popup";
    OpeningMode["popupWindow"] = "popup with widgets background";
    OpeningMode["fullScreenPopup"] = "fullScreenPopup";
    OpeningMode["inClient"] = "inClient";
    OpeningMode["userArea"] = "userArea";
    OpeningMode["mainView"] = "mainView";
    OpeningMode["bubble"] = "bubble";
})(OpeningMode = exports.OpeningMode || (exports.OpeningMode = {}));
var ProductPackageToID;
(function (ProductPackageToID) {
    ProductPackageToID[ProductPackageToID["PAYMENTS_DEPOSIT"] = 133] = "PAYMENTS_DEPOSIT";
    ProductPackageToID[ProductPackageToID["PAYMENTS_PSPREDIRECT"] = 134] = "PAYMENTS_PSPREDIRECT";
    ProductPackageToID[ProductPackageToID["POKER_GAMES_WIDGET"] = 135] = "POKER_GAMES_WIDGET";
    ProductPackageToID[ProductPackageToID["POKER_BLAST_GAME"] = 136] = "POKER_BLAST_GAME";
    ProductPackageToID[ProductPackageToID["CR_CHAT"] = 139] = "CR_CHAT";
    ProductPackageToID[ProductPackageToID["OPEN_BANKING"] = 9991] = "OPEN_BANKING";
    ProductPackageToID[ProductPackageToID["UPLOAD_DOCUMENTS"] = 9992] = "UPLOAD_DOCUMENTS";
    ProductPackageToID[ProductPackageToID["MOBILE_CASHIER"] = 69] = "MOBILE_CASHIER";
    ProductPackageToID[ProductPackageToID["FULL_CASHIER_MOBILE"] = 69] = "FULL_CASHIER_MOBILE";
    ProductPackageToID[ProductPackageToID["FULL_CASHIER_PC"] = 11] = "FULL_CASHIER_PC";
    ProductPackageToID[ProductPackageToID["PAYMENTS_CASHOUT"] = 140] = "PAYMENTS_CASHOUT";
    ProductPackageToID[ProductPackageToID["CUSTOMER_RELATIONS"] = 131] = "CUSTOMER_RELATIONS";
    ProductPackageToID[ProductPackageToID["POKER_HISTORY"] = 138] = "POKER_HISTORY";
    ProductPackageToID[ProductPackageToID["UNIFIED_CLIENT_NATIVE"] = 142] = "UNIFIED_CLIENT_NATIVE";
    ProductPackageToID[ProductPackageToID["MEMBERSHIP"] = 14] = "MEMBERSHIP";
    ProductPackageToID[ProductPackageToID["CR_CHAT_BUBBLE"] = 139] = "CR_CHAT_BUBBLE";
    ProductPackageToID[ProductPackageToID["PAYMENTS_PLAYER_TRANSACTIONS_HISTORY"] = 143] = "PAYMENTS_PLAYER_TRANSACTIONS_HISTORY";
    ProductPackageToID[ProductPackageToID["CR_HELP_CENTER"] = 139] = "CR_HELP_CENTER";
    ProductPackageToID[ProductPackageToID["OPEN_EMAIL"] = 9990] = "OPEN_EMAIL";
    ProductPackageToID[ProductPackageToID["OPEN_ONLINE_HELP"] = 9989] = "OPEN_ONLINE_HELP";
})(ProductPackageToID = exports.ProductPackageToID || (exports.ProductPackageToID = {}));
var LevelApp;
(function (LevelApp) {
    LevelApp["Regular"] = "Regular";
    LevelApp["Critical"] = "Critical";
})(LevelApp = exports.LevelApp || (exports.LevelApp = {}));
var PageType;
(function (PageType) {
    PageType["fullPage"] = "fullPage";
    PageType["virtualPage"] = "virtualPage";
})(PageType = exports.PageType || (exports.PageType = {}));
var SDKIdentifiers;
(function (SDKIdentifiers) {
    SDKIdentifiers["UnifiedCashier"] = "UnifiedCashier";
    SDKIdentifiers["Poker"] = "PokerSDK";
    SDKIdentifiers["PokerBlastPoolWidget"] = "PokerBlastPoolWidget";
    SDKIdentifiers["UcMockWidget"] = "UcMockWidgetSDK";
    SDKIdentifiers["PokerHistory"] = "PokerHistory";
    SDKIdentifiers["CRChat"] = "CRChat";
    SDKIdentifiers["CRChatBubble"] = "CRChatBubble";
    SDKIdentifiers["CRHelpCenter"] = "CRHelpCenter";
})(SDKIdentifiers = exports.SDKIdentifiers || (exports.SDKIdentifiers = {}));
var AppType;
(function (AppType) {
    AppType["App"] = "App";
    AppType["Game"] = "Game";
})(AppType = exports.AppType || (exports.AppType = {}));
var PaymentAppType;
(function (PaymentAppType) {
    PaymentAppType["FullCashier"] = "FullCashier";
    PaymentAppType["UnifiedCashier"] = "UnifiedCashier";
})(PaymentAppType = exports.PaymentAppType || (exports.PaymentAppType = {}));
var DeviceType;
(function (DeviceType) {
    DeviceType[DeviceType["Unknown"] = 0] = "Unknown";
    DeviceType[DeviceType["SmartPhone"] = 1] = "SmartPhone";
    DeviceType[DeviceType["Tablet"] = 2] = "Tablet";
    DeviceType[DeviceType["PC"] = 3] = "PC";
    DeviceType[DeviceType["Phablet"] = 4] = "Phablet";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));
var ActionID;
(function (ActionID) {
    ActionID["deposit"] = "deposit";
    ActionID["login"] = "login";
    ActionID["register"] = "register";
    ActionID["withdraw"] = "withdraw";
    ActionID["openPokerGame"] = "openPokerGame";
    ActionID["openPokerHistory"] = "openPokerHistory";
    ActionID["openChat"] = "openChat";
    ActionID["openBanking"] = "OPEN_BANKING";
    ActionID["uploadDocuments"] = "UPLOAD_DOCUMENTS";
    ActionID["openClientPage"] = "openClientPage";
    ActionID["openLink"] = "openLink";
    ActionID["transactionHistory"] = "transactionHistory";
    ActionID["openEmail"] = "openEmail";
    ActionID["openOnlineHelp"] = "openOnlineHelp";
    ActionID["openCashier"] = "openCashier";
    ActionID["openSurvey"] = "openSurvey";
    ActionID["openBetslip"] = "openBetslip";
    ActionID["openChallenges"] = "openChallenges";
    ActionID["openSpectatePage"] = "openSpectatePage";
})(ActionID = exports.ActionID || (exports.ActionID = {}));
var ClientPageType;
(function (ClientPageType) {
    ClientPageType["onlineHelp"] = "online-help";
})(ClientPageType = exports.ClientPageType || (exports.ClientPageType = {}));
var SDKStateEnum;
(function (SDKStateEnum) {
    SDKStateEnum["Loaded"] = "Loaded";
    SDKStateEnum["Error"] = "Error";
    SDKStateEnum["None"] = "None";
})(SDKStateEnum = exports.SDKStateEnum || (exports.SDKStateEnum = {}));
var AppStateEnum;
(function (AppStateEnum) {
    AppStateEnum["ProxyMode"] = "ProxyMode";
    AppStateEnum["Opening"] = "Opening";
    AppStateEnum["Active"] = "Active";
    AppStateEnum["Overlayed"] = "Overlayed";
    AppStateEnum["Deactivated"] = "Deactivated";
    AppStateEnum["Covered"] = "Covered";
    AppStateEnum["Closed"] = "Closed";
    AppStateEnum["Error"] = "Error";
    AppStateEnum["Minimized"] = "Minimized";
    AppStateEnum["AlwaysOnTop"] = "AlwaysOnTop";
})(AppStateEnum = exports.AppStateEnum || (exports.AppStateEnum = {}));
var ApplicationMode;
(function (ApplicationMode) {
    ApplicationMode["Full"] = "full";
    ApplicationMode["Proxy"] = "proxy";
    ApplicationMode["Mini"] = "mini";
})(ApplicationMode = exports.ApplicationMode || (exports.ApplicationMode = {}));
var IntegrationMethod;
(function (IntegrationMethod) {
    IntegrationMethod["Div"] = "div";
    IntegrationMethod["IFrame"] = "iFrame";
})(IntegrationMethod = exports.IntegrationMethod || (exports.IntegrationMethod = {}));
var OpeningMethod;
(function (OpeningMethod) {
    OpeningMethod["GNP"] = "GNP";
    OpeningMethod["UC"] = "UC";
})(OpeningMethod = exports.OpeningMethod || (exports.OpeningMethod = {}));
var ProxyModeType;
(function (ProxyModeType) {
    ProxyModeType["UI"] = "ui";
    ProxyModeType["NoUI"] = "noUi";
})(ProxyModeType = exports.ProxyModeType || (exports.ProxyModeType = {}));
var SupportedLanguages;
(function (SupportedLanguages) {
    SupportedLanguages["EN"] = "en";
    SupportedLanguages["PT"] = "pt";
    SupportedLanguages["FR"] = "fr";
    SupportedLanguages["ES"] = "es";
    SupportedLanguages["RU"] = "ru";
    SupportedLanguages["IT"] = "it";
    SupportedLanguages["DA"] = "da";
    SupportedLanguages["RO"] = "ro";
    SupportedLanguages["SV"] = "sv";
    SupportedLanguages["DE"] = "deu";
    SupportedLanguages["FI"] = "fi";
})(SupportedLanguages = exports.SupportedLanguages || (exports.SupportedLanguages = {}));
var OfferingNames;
(function (OfferingNames) {
    OfferingNames["Poker"] = "Poker";
    OfferingNames["Casino"] = "Casino";
    OfferingNames["Sport"] = "Sport";
})(OfferingNames = exports.OfferingNames || (exports.OfferingNames = {}));
//# sourceMappingURL=app-enums.js.map